import * as actionsTypesMembers from '../../actions/actionsTypesMembers'

function initialLogoutState() {
  return {
    isLoading: false,
    isError: false,
    isSuccess: false,
  }
}
export function logoutMembers(state, action) {
  let previousState = (state ? state : initialLogoutState())
  const { isLoading, isError, isSuccess } = action

  switch (action.type) {
    case actionsTypesMembers.LOGOUT_REQUEST :
      return {
        ...previousState,
        isLoading,
        isError: false,
        isSuccess: false,
      }
    case actionsTypesMembers.LOGOUT_FAILURE :
      return {
        ...previousState,
        isError,
        isSuccess: false,
      }
    case actionsTypesMembers.LOGOUT_SUCCESS:
      return {
        ...previousState,
        isSuccess,
        isError: false,
      }
    default :
      return previousState
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Authentification/Logout.js